export class Migalha {
  nome: string;
  link: string;
  templateLink?: any;
  redirect ? = false;
  mostrarMobile?: boolean;
  submenu?: Migalha[];

  static construirArray(objs: any[]): Migalha[] {
    return objs.map(value => new Migalha(value));
  }

  constructor(args) {
    Object.assign(this, args);
  }

}
